<template>
  <span :class="style.heading">DentalPro</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="Введите название"
      description="Название в списке"
      v-model="localIntegration.name"
    />
    <InputStyle
      size="M"
      placeholder="Введите токен"
      description="Token"
      v-model="localIntegration.token"
    />
    <InputStyle
      size="M"
      placeholder="Введите секретный ключ"
      description="Secret"
      v-model="localIntegration.secret"
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import style from "./settingIntegrations.module.scss";
import {defineComponent, PropType} from "vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import {dentalProIntegration} from "@/page/setting/integration/IntegrationTypes";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationDentalPro",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integration: {
      type: Object as PropType<dentalProIntegration>,
      default: () => ({})
    },
    integrationIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        name: this.integration?.name || "",
        token: this.integration?.token || "",
        secret: this.integration?.secret || ""
      }
    };
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.dentalPro;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] = {
          ...this.localIntegration
        };
      } else {
        integration.integration.push({...this.localIntegration});
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          name: newVal.name || "",
          token: newVal.token || "",
          secret: newVal.secret || ""
        };
      }
    }
  }
});
</script>
